import Bonus from './Bonus';

const VISIBLE_TIME = 7000;

export default class DoublePoints extends Bonus {
  constructor({ game, player, values, road }) {
    super({
      game,
      player,
      values,
      road,
      name: 'doublePoints',
    });
    this._chance = 0.002;
  }
  _setArea() {
    const radius = this.defaultHeight / 2;
    const offsetX = -(this.height - this.width) / 2;

    this.item.body.setCircle(radius, offsetX, this._bodyOffsetY);
  }
  _deactivate() {
    this._playerData.pointsMultipler = 1;
  }
  _take() {
    this._playerData.pointsMultipler = 2;
    super._take();
    if (this.timer) {
      this._game.time.events.remove(this.timer);
    }
    this.timer = this._game.time.events.add(VISIBLE_TIME, this._deactivate, this);
    this._player.activateAnimation(this._name);
  }
  create() {
    super.create();
    this._setArea();
  }
}



// WEBPACK FOOTER //
// ./src/js/DoublePoints.js